import { render } from "./newTable.vue?vue&type=template&id=69b9c46a&scoped=true&ts=true"
import script from "./newTable.vue?vue&type=script&lang=ts"
export * from "./newTable.vue?vue&type=script&lang=ts"

import "./newTable.vue?vue&type=style&index=0&id=69b9c46a&scoped=true&lang=css"
import "./newTable.vue?vue&type=style&index=1&id=69b9c46a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69b9c46a"]])

export default __exports__